import { render, staticRenderFns } from "./PhysicianProfile.vue?vue&type=template&id=e403ed58&"
import script from "./PhysicianProfile.vue?vue&type=script&lang=ts&"
export * from "./PhysicianProfile.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports